// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IContributionAmountDetailsDto
 */
export interface IContributionAmountDetailsDto {
    /**
     * 
     * @type {string}
     * @memberof IContributionAmountDetailsDto
     */
    plan_code?: string;
    /**
     * 
     * @type {number}
     * @memberof IContributionAmountDetailsDto
     */
    current_tax_year_employee_contribution_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IContributionAmountDetailsDto
     */
    current_tax_year_employer_contribution_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IContributionAmountDetailsDto
     */
    prior_tax_year_employee_contribution_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IContributionAmountDetailsDto
     */
    prior_tax_year_employer_contribution_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IContributionAmountDetailsDto
     */
    current_plan_year_employee_contribution_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IContributionAmountDetailsDto
     */
    current_plan_year_employer_contribution_amount?: number;
}

/**
 * Check if a given object implements the IContributionAmountDetailsDto interface.
 */
export function instanceOfIContributionAmountDetailsDto(value: object): value is IContributionAmountDetailsDto {
    return true;
}

export function IContributionAmountDetailsDtoFromJSON(json: any): IContributionAmountDetailsDto {
    return IContributionAmountDetailsDtoFromJSONTyped(json, false);
}

export function IContributionAmountDetailsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IContributionAmountDetailsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'plan_code': json['plan_code'] == null ? undefined : json['plan_code'],
        'current_tax_year_employee_contribution_amount': json['current_tax_year_employee_contribution_amount'] == null ? undefined : json['current_tax_year_employee_contribution_amount'],
        'current_tax_year_employer_contribution_amount': json['current_tax_year_employer_contribution_amount'] == null ? undefined : json['current_tax_year_employer_contribution_amount'],
        'prior_tax_year_employee_contribution_amount': json['prior_tax_year_employee_contribution_amount'] == null ? undefined : json['prior_tax_year_employee_contribution_amount'],
        'prior_tax_year_employer_contribution_amount': json['prior_tax_year_employer_contribution_amount'] == null ? undefined : json['prior_tax_year_employer_contribution_amount'],
        'current_plan_year_employee_contribution_amount': json['current_plan_year_employee_contribution_amount'] == null ? undefined : json['current_plan_year_employee_contribution_amount'],
        'current_plan_year_employer_contribution_amount': json['current_plan_year_employer_contribution_amount'] == null ? undefined : json['current_plan_year_employer_contribution_amount'],
    };
}

export function IContributionAmountDetailsDtoToJSON(json: any): IContributionAmountDetailsDto {
    return IContributionAmountDetailsDtoToJSONTyped(json, false);
}

export function IContributionAmountDetailsDtoToJSONTyped(value?: IContributionAmountDetailsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan_code': value['plan_code'],
        'current_tax_year_employee_contribution_amount': value['current_tax_year_employee_contribution_amount'],
        'current_tax_year_employer_contribution_amount': value['current_tax_year_employer_contribution_amount'],
        'prior_tax_year_employee_contribution_amount': value['prior_tax_year_employee_contribution_amount'],
        'prior_tax_year_employer_contribution_amount': value['prior_tax_year_employer_contribution_amount'],
        'current_plan_year_employee_contribution_amount': value['current_plan_year_employee_contribution_amount'],
        'current_plan_year_employer_contribution_amount': value['current_plan_year_employer_contribution_amount'],
    };
}

